import React from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { showAlert } from '../utils/utils';
import { outreachRepForDisplay, noteRepForDisplayAsActivity, sortIntoActivityGroups } from '../utils/activityProcessor';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import ActivitySummaryBox from './ActivitySummaryBox';
import ActionPanel from './ActionPanel';
import ActivityList from './ActivityList';
import KSpinner from './KSpinner';
import AlertModal from './AlertModal';

import facePageStyles from '../assets/jss/crm/views/facePageStyles';

class CondensedOrgActivityColumn extends React.Component {
  state = {
    loading: true,
    newNoteText: '',
    nActivities: 0,
    activityGroups: undefined,
  };

  componentDidMount() {
    this.loadRequiredData();
  }

  loadRequiredData() {
    const { visibleFirmId } = this.props;
    const referrerOrgId = visibleFirmId;
    const completionCallback = () => {
      this.buildActivityGroupsFromReduxStore(referrerOrgId);
      this.setState({ loading: false });
    };
    ReduxLoader.loadInfoForReferrerOrg(this, referrerOrgId, completionCallback);
  }

  buildActivityGroupsFromReduxStore(visibleFirmId) {
    const outreaches = DA.getOutreachesRelatedToVisibleFirm(visibleFirmId);
    const augmentedOutreaches = outreaches.map((outreach) => outreachRepForDisplay(outreach));
    const notes = this.getNotesAboutFirm(visibleFirmId);
    const augmentedNotes = notes.map((note) => noteRepForDisplayAsActivity(note));
    const outreachesAndNotes = augmentedOutreaches.concat(augmentedNotes);
    const activityGroups = sortIntoActivityGroups(outreachesAndNotes);
    this.setState({ activityGroups, nActivities: outreachesAndNotes.length });
  }

  getNotesAboutFirm(visibleFirmId) {
    return DA.getNotesAboutFirmWithId(visibleFirmId);
  }

  functionToShowSubject(activity) {
    switch (activity.subjectType) {
      case 'orgContact':
        return () => this.showOrgContactFaceSheet(activity.subjectId);
      case 'org':
        return () => showAlert(this, "You're already on the page for this organization");
      default:
        return () => showAlert(this, "Don't know how to show subject of type: " + activity.subjectType);
    }
  }

  showOrgContactFaceSheet(subjectId) {
    showAlert(this, 'Should now show the face sheet for org contact with ID: ' + subjectId);
  }

  createNote(noteText) {
    this.props.noteCreationFunc(noteText);
  }

  render() {
    if (this.state.loading) {
      return <KSpinner />;
    }

    const { classes, visibleFirmId, contacts } = this.props;
    const haveActivities =
      this.state.activityGroups && this.state.activityGroups[0] && this.state.activityGroups[0].activities[0];
    const lastInteractionTime = haveActivities ? this.state.activityGroups[0].activities[0].dateTime : 0;
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <div className={classes.activityColumn}>
          <ActivitySummaryBox nInteractions={this.state.nActivities} lastInteractionTime={lastInteractionTime} />
          <ActionPanel
            activityColumn={this}
            visibleFirmId={visibleFirmId}
            contacts={contacts}
            noteCreationFunc={(noteText) => this.createNote(noteText)}
          />

          <ActivityList
            activityGroups={this.state.activityGroups}
            functionToShowSubject={(activity) => this.functionToShowSubject(activity)}
            rerenderPageFunc={() => this.loadRequiredData()}
            page={this}
            contacts={contacts}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
  taskInfo: state.taskInfo,
  firms: state.firms,
});
const actionProducers = { setApiResponseInfo };
export default connect(mapStateToProps, actionProducers)(withStyles(facePageStyles)(CondensedOrgActivityColumn));
